module.exports = __webpack_public_path__ + "img/finance.d7307ee3.svg";